import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="max-attendees-toggle"
export default class extends Controller {
  static targets = ["input", "field"]

  static values = {
    threshold: Number
  }

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    if (!this.hasInputTarget || !this.hasFieldTarget) return

    const value = parseInt(this.inputTarget.value, 10)
    const threshold = this.hasThresholdValue ? this.thresholdValue : 1
    const shouldShow = Number.isFinite(value) && value > threshold

    this.fieldTarget.classList.toggle("d-none", !shouldShow)
    this.fieldTarget.classList.toggle("hidden", !shouldShow)
  }
}
